<header>
  <div class="wrap">
    <div class="text">
      <h2 class="title">{{ title }}</h2>
      <div class="my-5" *ngIf="message != undefined">{{ message }}</div>
      <div class="my-5" *ngIf="messages != undefined && messages.length > 0">
        <table>
          <tbody>
            <tr *ngFor="let my_message of messages">
              <div>- {{ my_message }}</div>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="header-actions">
      <button class="close" (click)="modalService.close()" title="{{ 'generic.close' | translate }}">
        <span class="icon-view-close" aria-hidden="true">
          <svg>
            <use xlink:href="assets/img/icons.svg#icon-view-close"></use>
          </svg>
        </span>
        <span>{{ 'generic.close' | translate }}</span>
      </button>
    </div>
  </div>
</header>
<div class="main">
  <footer class="popin-footer">
    <ng-casto-btn
      class="blue"
      [label]="'popins.closet-doors-administration-message.confirm' | translate"
      (click)="modalService.close()"></ng-casto-btn>
  </footer>
</div>
